export var TABLE_VARIANTS;
(function (TABLE_VARIANTS) {
    TABLE_VARIANTS[TABLE_VARIANTS["FIRST_COLOMN_FIXED"] = 0] = "FIRST_COLOMN_FIXED";
})(TABLE_VARIANTS || (TABLE_VARIANTS = {}));
//# sourceMappingURL=VirtualTable.enum.js.map